export default __webpack_public_path__ + "static/media/search.5f80ac13.svg";